import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { useMenu } from '@ers/hooks';
import { UnreadCounter as UnreadCounterHooked } from '@ers/ui';
import { UnreadCounter } from '@ers/ui/UnreadCounter';

export default function MenuTrigger({ storyBook }) {
    const { open } = useMenu();
    const handleClick = useCallback(open);
    return (
        <div className="menu-trigger__parent">
            <button type="button" className={cx('menu-trigger', { 'menu-trigger--center': storyBook })} onClick={handleClick}>
                <i className="menu-trigger__bar">--</i>
                <i className="menu-trigger__bar">--</i>
                <i className="menu-trigger__bar">--</i>
            </button>
            {storyBook ? <UnreadCounter /> : <UnreadCounterHooked />}
        </div>
    );
}
MenuTrigger.propTypes = {
    storyBook: PropTypes.bool
};
MenuTrigger.defaultProps = {
    storyBook: false,
};
